export function GetDaysApartCount(
  dateOne: string,
  dateTwo: string
): number | null {
  if (!dateOne || !dateTwo) {
    return null;
  }
  const firstDate = new Date(dateOne).getTime();
  const secondDate = new Date(dateTwo).getTime();
  const oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds

  const differenceInMs = Math.abs(firstDate - secondDate);
  const differenceInDays = Math.round(differenceInMs / oneDay);
  return differenceInDays;
}
